import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
export function DatenschutzPage() {
  const {
    language
  } = useLanguage();
  const isGerman = language === 'de';
  const content = isGerman ? germanContent : englishContent;
  const youtubePrivacyUrl = isGerman ? 'https://policies.google.com/privacy?hl=de' : 'https://policies.google.com/privacy?hl=en';
  return <div className="min-h-screen bg-[#0a0e1a]" data-id="element-452">
      <Navigation data-id="element-453" />
      <main className="pt-24 pb-16" data-id="element-454">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-455">
          <h1 className="text-4xl font-bold text-white mb-12" data-id="element-456">
            {content.title}
          </h1>

          <div className="prose prose-invert max-w-none space-y-8 text-gray-400" data-id="element-457">
            <section data-id="element-458">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-459">
                {content.overview.title}
              </h2>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-460">
                {content.overview.generalNotesTitle}
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-461">
                {content.overview.generalNotes}
              </p>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-462">
                {content.overview.collectionTitle}
              </h3>

              <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-463">
                {content.overview.controllerQuestion}
              </h4>
              <p className="leading-relaxed mb-4" data-id="element-464">
                {content.overview.controllerAnswer}
              </p>

              <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-465">
                {content.overview.collectionQuestion}
              </h4>
              <p className="leading-relaxed mb-4" data-id="element-466">
                {content.overview.collectionAnswerOne}
              </p>
              <p className="leading-relaxed mb-4" data-id="element-467">
                {content.overview.collectionAnswerTwo}
              </p>

              <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-468">
                {content.overview.usageQuestion}
              </h4>
              <p className="leading-relaxed mb-4" data-id="element-469">
                {content.overview.usageAnswer}
              </p>

              <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-470">
                {content.overview.rightsQuestion}
              </h4>
              <p className="leading-relaxed mb-4" data-id="element-471">
                {content.overview.rightsAnswerOne}
              </p>
              <p className="leading-relaxed mb-4" data-id="element-472">
                {content.overview.rightsAnswerTwo}
              </p>

              <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-473">
                {content.overview.analyticsTitle}
              </h4>
              <p className="leading-relaxed mb-4" data-id="element-474">
                {content.overview.analyticsAnswerOne}
              </p>
              <p className="leading-relaxed mb-4" data-id="element-475">
                {content.overview.analyticsAnswerTwo}
              </p>
            </section>

            <section data-id="element-476">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-477">
                {content.hosting.title}
              </h2>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-478">
                Webflow
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-479">
                {content.hosting.paragraphOne}
              </p>
              <p className="leading-relaxed mb-4" data-id="element-480">
                {content.hosting.paragraphTwo}
              </p>
              <p className="leading-relaxed mb-4" data-id="element-481">
                {content.hosting.privacyIntro}{' '}
                <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-482">
                  https://webflow.com/legal/eu-privacy-policy
                </a>
                .
              </p>
              <p className="leading-relaxed mb-4" data-id="element-483">
                {content.hosting.paragraphThree}
              </p>
              <p className="leading-relaxed mb-4" data-id="element-484">
                {content.hosting.transferIntro}{' '}
                <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-485">
                  https://webflow.com/legal/eu-privacy-policy
                </a>
                .
              </p>
            </section>

            <section data-id="element-486">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-487">
                {content.general.title}
              </h2>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-488">
                {content.general.privacyTitle}
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-489">
                {content.general.privacyParagraphOne}
              </p>
              <p className="leading-relaxed mb-4" data-id="element-490">
                {content.general.privacyParagraphTwo}
              </p>
              <p className="leading-relaxed mb-4" data-id="element-491">
                {content.general.privacyParagraphThree}
              </p>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-492">
                {content.general.controllerTitle}
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-493">
                {content.general.controllerIntro}
              </p>
              <p className="leading-relaxed mb-4" data-id="element-494">
                CRM Kraft LLC
                <br data-id="element-495" />
                {content.general.representedBy}
                <br data-id="element-496" />
                7901 4th St. N, Ste. 300
                <br data-id="element-497" />
                St. Petersburg, FL 33702
                <br data-id="element-498" />
                United States of America
                <br data-id="element-499" />
                {content.general.phoneLabel}: +49 157 35999071
                <br data-id="element-500" />
                {content.general.emailLabel}: justus@crm-kraft.de
              </p>
              <p className="leading-relaxed mb-4" data-id="element-501">
                {content.general.controllerDescription}
              </p>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-502">
                {content.general.retentionTitle}
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-503">
                {content.general.retentionText}
              </p>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-504">
                {content.general.encryptionTitle}
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-505">
                {content.general.encryptionParagraphOne}
              </p>
              <p className="leading-relaxed mb-4" data-id="element-506">
                {content.general.encryptionParagraphTwo}
              </p>
            </section>

            <section data-id="element-507">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-508">
                {content.collection.title}
              </h2>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-509">
                {content.collection.cookiesTitle}
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-510">
                {content.collection.cookiesText}
              </p>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-511">
                {content.collection.contactFormTitle}
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-512">
                {content.collection.contactFormText}
              </p>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-513">
                {content.collection.contactTitle}
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-514">
                {content.collection.contactText}
              </p>
            </section>

            <section data-id="element-515">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-516">
                {content.tools.title}
              </h2>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-517">
                YouTube
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-518">
                {content.tools.youtubeParagraphOne}
              </p>
              <p className="leading-relaxed mb-4" data-id="element-519">
                {content.tools.youtubePrivacyIntro}{' '}
                <a href={youtubePrivacyUrl} target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-520">
                  {youtubePrivacyUrl}
                </a>
                .
              </p>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-521">
                Google Web Fonts
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-522">
                {content.tools.webFontsText}
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer data-id="element-523" />
    </div>;
}
const germanContent = {
  title: 'Datenschutzerklärung',
  overview: {
    title: '1. Datenschutz auf einen Blick',
    generalNotesTitle: 'Allgemeine Hinweise',
    generalNotes: 'Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.',
    collectionTitle: 'Datenerfassung auf dieser Website',
    controllerQuestion: 'Wer ist verantwortlich für die Datenerfassung auf dieser Website?',
    controllerAnswer: 'Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.',
    collectionQuestion: 'Wie erfassen wir Ihre Daten?',
    collectionAnswerOne: 'Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.',
    collectionAnswerTwo: 'Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.',
    usageQuestion: 'Wofür nutzen wir Ihre Daten?',
    usageAnswer: 'Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.',
    rightsQuestion: 'Welche Rechte haben Sie bezüglich Ihrer Daten?',
    rightsAnswerOne: 'Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.',
    rightsAnswerTwo: 'Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.',
    analyticsTitle: 'Analyse-Tools und Tools von Drittanbietern',
    analyticsAnswerOne: 'Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor allem mit sogenannten Analyseprogrammen.',
    analyticsAnswerTwo: 'Detaillierte Informationen zu diesen Analyseprogrammen finden Sie in der folgenden Datenschutzerklärung.'
  },
  hosting: {
    title: '2. Hosting',
    paragraphOne: 'Wir hosten unsere Website bei Webflow. Anbieter ist die Webflow, Inc., 398 11th Street, 2nd Floor, San Francisco, CA 94103, USA (nachfolgend Webflow). Wenn Sie unsere Website besuchen, erfasst Webflow verschiedene Logfiles inklusive Ihrer IP-Adressen.',
    paragraphTwo: 'Webflow ist ein Tool zum Erstellen und zum Hosten von Websites. Webflow speichert Cookies oder sonstige Wiedererkennungstechnologien, die für die Darstellung der Seite, zur Bereitstellung bestimmter Webseitenfunktionen und zur Gewährleistung der Sicherheit erforderlich sind (notwendige Cookies).',
    privacyIntro: 'Details entnehmen Sie der Datenschutzerklärung von Webflow:',
    paragraphThree: 'Die Verwendung von Webflow erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an einer möglichst zuverlässigen Darstellung unserer Website. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TTDSG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endgerät des Nutzers (z. B. Device-Fingerprinting) im Sinne des TTDSG umfasst. Die Einwilligung ist jederzeit widerrufbar.',
    transferIntro: 'Die Datenübertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gestützt. Details finden Sie hier:'
  },
  general: {
    title: '3. Allgemeine Hinweise und Pflichtinformationen',
    privacyTitle: 'Datenschutz',
    privacyParagraphOne: 'Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.',
    privacyParagraphTwo: 'Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.',
    privacyParagraphThree: 'Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.',
    controllerTitle: 'Hinweis zur verantwortlichen Stelle',
    controllerIntro: 'Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:',
    representedBy: 'Vertreten durch: Justus Kraft',
    phoneLabel: 'Telefon',
    emailLabel: 'E-Mail',
    controllerDescription: 'Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.',
    retentionTitle: 'Speicherdauer',
    retentionText: 'Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.',
    encryptionTitle: 'SSL- bzw. TLS-Verschlüsselung',
    encryptionParagraphOne: 'Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.',
    encryptionParagraphTwo: 'Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.'
  },
  collection: {
    title: '4. Datenerfassung auf dieser Website',
    cookiesTitle: 'Cookies',
    cookiesText: 'Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst löschen oder eine automatische Löschung durch Ihren Webbrowser erfolgt.',
    contactFormTitle: 'Kontaktformular',
    contactFormText: 'Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.',
    contactTitle: 'Anfrage per E-Mail, Telefon oder Telefax',
    contactText: 'Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.'
  },
  tools: {
    title: '5. Plugins und Tools',
    youtubeParagraphOne: 'Diese Website bindet Videos der Website YouTube ein. Betreiber der Website ist die Google Ireland Limited („Google"), Gordon House, Barrow Street, Dublin 4, Irland.',
    youtubePrivacyIntro: 'Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerklärung von YouTube unter:',
    webFontsText: 'Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Web Fonts, die von Google bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web Fonts in ihren Browsercache, um Texte und Schriftarten korrekt anzuzeigen.'
  }
};
const englishContent = {
  title: 'Privacy Policy',
  overview: {
    title: '1. Privacy at a Glance',
    generalNotesTitle: 'General Information',
    generalNotes: 'The following information provides a simple overview of what happens to your personal data when you visit this website. Personal data is any data that can be used to identify you personally. Detailed information on data protection can be found in our privacy policy below.',
    collectionTitle: 'Data Collection on This Website',
    controllerQuestion: 'Who is responsible for data collection on this website?',
    controllerAnswer: 'Data processing on this website is carried out by the website operator. You can find their contact details in the “Responsible Entity / Data Controller” section of this privacy policy.',
    collectionQuestion: 'How do we collect your data?',
    collectionAnswerOne: 'On the one hand, your data is collected when you provide it to us. This may include data that you enter in a contact form.',
    collectionAnswerTwo: 'Other data is collected automatically by our IT systems when you visit the website, or after you have given your consent. This is primarily technical data, such as your internet browser, operating system, or the time of page access. This data is collected automatically as soon as you enter this website.',
    usageQuestion: 'What do we use your data for?',
    usageAnswer: 'Some data is collected to ensure that the website is provided without errors. Other data may be used to analyze your user behavior.',
    rightsQuestion: 'What rights do you have regarding your data?',
    rightsAnswerOne: 'You have the right at any time to obtain information free of charge about the origin, recipient, and purpose of your stored personal data. You also have the right to request the correction or deletion of this data. If you have given consent to data processing, you can revoke this consent at any time with effect for the future. You also have the right, under certain circumstances, to request the restriction of the processing of your personal data. Furthermore, you have the right to lodge a complaint with the competent supervisory authority.',
    rightsAnswerTwo: 'You may contact us at any time regarding these matters or any further questions concerning data protection.',
    analyticsTitle: 'Analytics Tools and Third-Party Tools',
    analyticsAnswerOne: 'When you visit this website, your browsing behavior may be statistically evaluated. This is mainly carried out using so-called analytics programs.',
    analyticsAnswerTwo: 'Detailed information about these analytics programs can be found in the following privacy policy.'
  },
  hosting: {
    title: '2. Hosting',
    paragraphOne: 'We host our website with Webflow. The provider is Webflow, Inc., 398 11th Street, 2nd Floor, San Francisco, CA 94103, USA (hereinafter “Webflow”). When you visit our website, Webflow collects various log files, including your IP address.',
    paragraphTwo: 'Webflow is a tool for creating and hosting websites. Webflow stores cookies or other recognition technologies that are necessary for displaying the website, providing certain website functions, and ensuring security (necessary cookies).',
    privacyIntro: 'For details, please refer to Webflow’s privacy policy:',
    paragraphThree: 'Webflow is used on the basis of Art. 6(1)(f) GDPR. We have a legitimate interest in ensuring that our website is displayed as reliably as possible. Where consent has been requested, processing is carried out exclusively on the basis of Art. 6(1)(a) GDPR and Section 25(1) TTDSG, insofar as the consent includes the storage of cookies or access to information on the user’s device, such as device fingerprinting, within the meaning of the TTDSG. Consent may be revoked at any time.',
    transferIntro: 'Data transfers to the United States are based on the European Commission’s standard contractual clauses. Details can be found here:'
  },
  general: {
    title: '3. General Information and Mandatory Disclosures',
    privacyTitle: 'Data Protection',
    privacyParagraphOne: 'The operators of these pages take the protection of your personal data very seriously. We treat your personal data confidentially and in accordance with statutory data protection regulations and this privacy policy.',
    privacyParagraphTwo: 'When you use this website, various personal data is collected. Personal data is data that can be used to identify you personally. This privacy policy explains what data we collect and what we use it for. It also explains how and for what purpose this takes place.',
    privacyParagraphThree: 'Please note that data transmission over the internet, for example when communicating by email, may have security gaps. Complete protection of data against access by third parties is not possible.',
    controllerTitle: 'Responsible Entity / Data Controller',
    controllerIntro: 'The responsible entity for data processing on this website is:',
    representedBy: 'Represented by: Justus Kraft',
    phoneLabel: 'Phone',
    emailLabel: 'Email',
    controllerDescription: 'The responsible entity is the natural or legal person who, alone or jointly with others, determines the purposes and means of processing personal data, for example names or email addresses.',
    retentionTitle: 'Storage Period',
    retentionText: 'Unless a more specific storage period has been stated in this privacy policy, your personal data will remain with us until the purpose for data processing no longer applies. If you submit a legitimate request for deletion or revoke your consent to data processing, your data will be deleted unless we have other legally permissible reasons for storing your personal data, such as retention periods under tax or commercial law. In the latter case, deletion will take place once these reasons no longer apply.',
    encryptionTitle: 'SSL / TLS Encryption',
    encryptionParagraphOne: 'For security reasons and to protect the transmission of confidential content, such as orders or inquiries that you send to us as the website operator, this website uses SSL or TLS encryption. You can recognize an encrypted connection by the browser address bar changing from “http://” to “https://” and by the lock symbol in your browser bar.',
    encryptionParagraphTwo: 'When SSL or TLS encryption is enabled, the data you transmit to us cannot be read by third parties.'
  },
  collection: {
    title: '4. Data Collection on This Website',
    cookiesTitle: 'Cookies',
    cookiesText: 'Our websites use so-called “cookies”. Cookies are small text files and do not cause any damage to your device. They are stored either temporarily for the duration of a session, known as session cookies, or permanently, known as persistent cookies, on your device. Session cookies are automatically deleted at the end of your visit. Persistent cookies remain stored on your device until you delete them yourself or your web browser deletes them automatically.',
    contactFormTitle: 'Contact Form',
    contactFormText: 'If you send us inquiries using the contact form, we will store the information you provide in the inquiry form, including the contact details you provide there, for the purpose of processing your inquiry and in case of follow-up questions. We will not share this data without your consent.',
    contactTitle: 'Requests by Email, Telephone, or Fax',
    contactText: 'If you contact us by email, telephone, or fax, your inquiry, including all personal data resulting from it, such as name and inquiry, will be stored and processed by us for the purpose of handling your request. We will not share this data without your consent.'
  },
  tools: {
    title: '5. Plugins and Tools',
    youtubeParagraphOne: 'This website embeds videos from YouTube. The website operator is Google Ireland Limited (“Google”), Gordon House, Barrow Street, Dublin 4, Ireland.',
    youtubePrivacyIntro: 'Further information about the handling of user data can be found in YouTube’s privacy policy at:',
    webFontsText: 'This website uses web fonts provided by Google for the uniform display of fonts. When you access a page, your browser loads the required web fonts into its browser cache in order to display text and fonts correctly.'
  }
};